export class PostGetPatientPrimaryCareProviderRequest {
    patientId: string | null = null;
    myChartAccountId: string | null = null;
    patientAge: number | null = null;
    longitude?: number;
    latitude?: number;
    maxDisplayCount: number = 3;
}